import Typography from "@mui/material/Typography";
import { FormattedMessage, useIntl } from "react-intl";

import { TVehicle } from "types";
import { Tupel } from "components";

interface IEmissions {
  vehicle: TVehicle;
}

const PlugInHybridDiesel: React.FC<IEmissions> = ({ vehicle }): JSX.Element => {
  const { formatNumber: n } = useIntl();
  return (
    <>
      <Tupel
        force
        labelId="term.antriebsart"
        label="Antriebsart"
        textId="term.plugin_hybrid"
        text="Plug-In-Hybrid"
      />
      <Tupel
        force
        labelId="term.kraftstoff"
        label="Kraftstoff"
        textId="term.diesel"
        text="Diesel"
      />
      <Tupel
        force
        labelId="term.anderer_energietraeger"
        label="Anderer Energietr&auml;ger"
        textId="term.strom"
        text="Strom"
      />
      <Typography variant="h6" component="h3" sx={{ mt: 3 }}>
        <FormattedMessage
          id="term.Energieverbrauch"
          defaultMessage="Energieverbrauch"
        />
      </Typography>
      <Tupel
        force
        labelId="term.weighted_combined"
        label="gewichtet, kombiniert"
        text={`${n(vehicle.wltp_stromverbrauch_kombiniert)} kWh/100km + ${n(vehicle.wltp_kombiniert)} l/100km`}
        footnote={1}
      />
      <Typography variant="h6" component="h3" sx={{ mt: 3 }}>
        <FormattedMessage
          id="term.co2Emission.default"
          defaultMessage="CO&#8322;-Emissionen"
        />
      </Typography>
      <Tupel
        force
        labelId="term.weighted_combined"
        label="gewichtet, kombinert"
        number={vehicle.wltp_co2_emissionen}
        unit="g/km"
        footnote={1}
      />
      <Typography variant="h6" component="h3" sx={{ mt: 3 }}>
        <FormattedMessage
          id="term.elektrische_reichweite"
          defaultMessage="Elektrische Reichweite"
        />
      </Typography>
      <Tupel
        force
        labelId="term.eaer"
        label="EAER"
        number={vehicle.wltp_elektro_reichweite_max || 0}
        unit="km"
      />
    </>
  );
};

export default PlugInHybridDiesel;
